import { Component, OnInit } from '@angular/core';
import { FlightLevelType, MaxflightlevelUnit } from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { Events } from '@app/shared/services/events.service';
@Component({
    selector: 'app-alternate',
    templateUrl: './alternate.component.html',
    styleUrls: ['./alternate.component.scss'],
    standalone: false
})
export class AlternateComponent implements OnInit {
  public disablealt1RouteOption: boolean = false;
  public disablealt2RouteOption: boolean = false;
  public disableFlightlevelSelection: boolean = false;
  public disableFlightlevelSelection2: boolean = false;
  public flightLevelType = FlightLevelType;
  public maxflightlevelUnit = MaxflightlevelUnit;
  private autoBackupAlt1: any = { code: '', route: '' };
  private autoBackupAlt2: any = { code: '', route: '' };
  private autoBackUpAlt2: any =  { code: '', route: '' };
  private autoBackUpALt2: any = { code: '', route: '' };
  private onClearFlag: boolean = false;
  constructor(public flightPlanService: FlightPlanService, private events: Events,) { }

  public ngOnInit() {
    this.toggle();
    this.toggle1();
    this.flightLevelToggle();
    this.flightLevelToggle2();
   }
  private saveInitialAutoValues() {
    if (this.flightPlanService.alternate.alt1) {
    this.autoBackupAlt1.code = this.flightPlanService.alternate.alt1;
    this.autoBackupAlt1.route = this.flightPlanService.alternate.alt1Route;
    }
   if (this.flightPlanService.alternate.alt2) {
    this.autoBackupAlt2.code = this.flightPlanService.alternate.alt2;
    this.autoBackupAlt2.route = this.flightPlanService.alternate.alt2Route;
    }
}
public setInitialAutoValues() {
    this.autoBackUpAlt2.code = this.flightPlanService.alternate.alt2;
    this.autoBackUpAlt2.route = this.flightPlanService.alternate.alt2Route;
}
public setInitialValuesAuto () {
  this.autoBackUpALt2.code = this.flightPlanService.alternate.alt2;
  this.autoBackUpALt2.route = this.flightPlanService.alternate.alt2Route;
}
  public openAccordian() {
    this.flightPlanService.accordionSwitch('alternate');
    this.toggle();
    this.toggle1();
    this.flightLevelToggle();
    this.flightLevelToggle2();
  }
  public toggle() {
    this.flightPlanService.alternate.alt1RouteOption == "alt1RouteOptionmanual"
      ? (this.disablealt1RouteOption = true)
      : (this.disablealt1RouteOption = false);
    if(this.flightPlanService.alternate.alt1RouteOption == "alt1RouteOptionauto" &&  this.flightPlanService.alternate.alt1 == null &&
    this.flightPlanService.alternate.alt1Route == null){
       this.flightPlanService.alternate.alt1 =  this.autoBackupAlt1.code;
    this.flightPlanService.alternate.alt1Route = this.autoBackupAlt1.route;
    }
  }
  public toggle1() {
    this.flightPlanService.alternate.alt2RouteOption == "alt2RouteOptionmanual"
      ? (this.disablealt2RouteOption = true)
      : (this.disablealt2RouteOption = false);
    if(this.flightPlanService.alternate.alt2RouteOption == "alt2RouteOptionauto" && this.onClearFlag) {
      this.flightPlanService.alternate.alt2 = this.autoBackupAlt2.code;
    this.flightPlanService.alternate.alt2Route = this.autoBackupAlt2.route;
    }
    if(this.flightPlanService.alternate.alt2RouteOption == "alt2RouteOptionauto" && this.flightPlanService.toggleFlagToAuto) {
        this.flightPlanService.alternate.alt2 = this.autoBackUpAlt2.code;
    this.flightPlanService.alternate.alt2Route = this.autoBackUpAlt2.route;
    }
  }
  public showAlternate(type: string) {
    if (this.flightPlanService.alternate.alt2 == null) {
      this.setInitialAutoValues();
      this.flightPlanService.toggleFlagToAuto = true;
    } else {
      this.setInitialValuesAuto()
      this.flightPlanService.toggleFlagToAuto = false;
    }
    this.flightPlanService.showAlternate(type);
  }
  public flightLevelToggle() {
    this.disableFlightlevelSelection =
      this.flightPlanService.alternate.flightLevelType1 == "ExactFlightLevelSpecification" ? true : false;
  }
  public flightLevelToggle2() {
    this.disableFlightlevelSelection2 =
      this.flightPlanService.alternate.flightLevelType2 == "ExactFlightLevelSpecification" ? true : false;
  }
  public getFormatedProfile(profileName: string) {
    switch (profileName.toLowerCase()) {
      case "long range cruise":
        return "LRC";
      case "max spd cruise":
        return "Max";
      case "max speed cruise":
        return "MAX";
      default:
        return profileName.indexOf("Mach") >= 0 ? profileName.replace("Mach 0", "M") : profileName;
    }
  }
  public emitEvent(event:any) {
    this.events.publish(
      "alternateOnInput",
      event
    );
  }
  public selectOperationType() { }
  public clearAlternate(altNumber: number) {
    this.saveInitialAutoValues();
  if (altNumber === 1) {
    this.flightPlanService.alternate.alt1 = null;
    this.flightPlanService.alternate.alt1Route = null;
    this.disablealt1RouteOption = true;
    this.onClearFlag = true;
  } else if (altNumber === 2) {
    this.flightPlanService.alternate.alt2 = null;
    this.flightPlanService.alternate.alt2Route = null;
    this.disablealt2RouteOption = true;
    this.onClearFlag = true;
  }
}
}
